export default __webpack_public_path__ + "static/media/UNION_black_A5.69604435.png";